import { lenis } from "./lenis"

export const anchorLinks = () => {

  const links = document.querySelectorAll('a')
  const params = window.location.search

  if (params) {
    setTimeout(() => {
      lenis.scrollTo(document.querySelector(`#${params.substring(1)}`))
    }, 500)
  }

  links.forEach(link => {
    if (link.getAttribute('href').startsWith('#') && link.getAttribute('href').length > 1) {
      const section = document.querySelector(link.getAttribute('href'))

      if (section) {
        link.addEventListener('click', (e) => {
          e.preventDefault()
          lenis.scrollTo(section)
        })
      } else {
        link.addEventListener('click', (e) => {
          e.preventDefault()
          window.location.href = `/?${link.getAttribute('href').substring(1)}`
        })
      }
    }
  })
  
}

export default () => { }